//vue
import Vue from 'vue';
import VueRouter from 'vue-router';
//base
import Login from '../views/Login.vue';
import Home from '../views/Home.vue';
//trunk
import Trunk from '../views/trunk/Index.vue';
import TrunkList from '../views/trunk/List.vue';
import TrunkForm from '../views/trunk/Form.vue';
import TrunkDetails from '../views/trunk/Details.vue';
import TrunkRoutes from '../views/trunk/Routes.vue';
//plan
import Plan from '../views/plan/Index.vue';
import PlanList from '../views/plan/List.vue';
import PlanForm from '../views/plan/Form.vue';
import PlanDetails from '../views/plan/Details.vue';
import PlanRoutes from '../views/plan/Routes.vue';
//client
import Client from '../views/client/Index.vue';
import ClientList from '../views/client/List.vue';
import ClientForm from '../views/client/Form.vue';
import ClientCompels from '../views/client/Compels.vue';
import ClientDetails from '../views/client/Details.vue';
//sipline
import SIPLine from '../views/sipline/Index.vue';
import SIPLineList from '../views/sipline/List.vue';
import SIPLineDetails from '../views/sipline/Details.vue';
import SIPLineForm from '../views/sipline/Form.vue';
import SIPLineReport from '../views/sipline/Report.vue';
//did
import DID from '../views/did/Index.vue';
import DIDList from '../views/did/List.vue';
import DIDDetails from '../views/did/Details.vue';
import DIDForm from '../views/did/Form.vue';
import DIDReport from '../views/did/Report.vue';
//credit
import Credit from '../views/credit/Index.vue';
import CreditList from '../views/credit/List.vue';
//call
import Call from '../views/call/Index.vue';
import CallList from '../views/call/List.vue';
//log
import Log from '../views/log/Index.vue';
import LogList from '../views/log/List.vue';
//channel
import Channel from '../views/channel/Index.vue';
import ChannelList from '../views/channel/List.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    redirect: "/home"
  },
  {
    path: '/login',
    component: Login 
  },
  {
    path: '/home',
    component: Home
  },
  {
    path: '/trunk',
    component: Trunk,
    children: [
      {
        path: "/",
        component: TrunkList
      },
      {
        path: "new",
        component: TrunkForm
      },
      {
        path: ":id",
        component: TrunkDetails
      },
      {
        path: ":id/routes",
        component: TrunkRoutes
      }
    ]
  },
  {
    path: '/plan',
    component: Plan,
    children: [
      {
        path: "/",
        component: PlanList
      },
      {
        path: "new",
        component: PlanForm
      },
      {
        path: ":id",
        component: PlanDetails
      },
      {
        path: ":id/routes",
        component: PlanRoutes
      }
    ]
  },
  {
    path: '/client',
    component: Client,
    children: [
      {
        path: "/",
        component: ClientList
      },
      {
        path: "new",
        component: ClientForm
      },
      {
        path: "compels",
        component: ClientCompels
      },
      {
        path: ":id",
        component: ClientDetails
      }
    ]
  },
  {
    path: '/sipline',
    component: SIPLine,
    children: [
      {
        path: "/",
        component: SIPLineList
      },
      {
        path: "new",
        component: SIPLineForm
      },
      {
        path: "report",
        component: SIPLineReport
      },
      {
        path: ":id",
        component: SIPLineDetails
      }
    ]
  },
  {
    path: '/did',
    component: DID,
    children: [
      {
        path: "/",
        component: DIDList
      },
      {
        path: "new",
        component: DIDForm
      },
      {
        path: "report",
        component: DIDReport
      },
      {
        path: ":id",
        component: DIDDetails
      }
    ]
  },
  {
    path: '/credit',
    component: Credit,
    children: [
      {
        path: "/",
        component: CreditList
      }
    ]
  },
  {
    path: '/call',
    component: Call,
    children: [
      {
        path: ":id",
        component: CallList
      }
    ]
  },
  {
    path: '/log',
    component: Log,
    children: [
      {
        path: "/",
        component: LogList
      }
    ]
  },
  {
    path: '/channel',
    component: Channel,
    children: [
      {
        path: "/",
        component: ChannelList
      }
    ]
  }
];

const router = new VueRouter({
  routes
});

export default router;
